import React, { useEffect, useState } from "react";
import "../css/ProductDetails.css";
import { getProductDetailsItem } from "../localStorage";
import ProductImageCarousel from "../component/ProductImageCarousel";
import ContactUsModalView from "../component/ContactUsModalView";
import ContactUsFormComp from "../component/ContactUsFormComp";

const ProductDetails = () => {
	let productDetails = getProductDetailsItem();
	const [showContactModal, setShowContactModal] = useState(false);
	const [messageSendFlag, setMessageSendFlag] = useState(false);
	useEffect(() => {
		if (messageSendFlag) {
			setShowContactModal(false);
			setMessageSendFlag(false);
		}
	}, [messageSendFlag]);

	const { productId, productTitle, productDescription, postImageArray } =
		productDetails;
	return (
		<div className="">
			<div className="text-center category-header pt-4">
				<span>Product Details</span>
			</div>
			<div className="container product-details" id={productId}>
				<div className="product-detail-img">
					<ProductImageCarousel imageArray={[...postImageArray]} />
				</div>

				<div className="product-detail-description">
					{/* Breadcrumb */}
					<div className="product-breadcrumb">
						Home / Products / {productDetails.productTitle}
					</div>

					{/* Existing Title */}
					<div className="product-detail-title">{productTitle}</div>

					{/* New subtitle */}
					<div className="product-subtitle">
						Engineered for quality, performance, and reliability
					</div>

					{/* Existing Description */}
					<div className="product-detail-description-text">
						{productDescription}
					</div>

					<div className="product-quick-features">
						{/* <div className="feature-card">🚚 Free Shipping</div> */}
						<div className="feature-card">
							✔ 100% Quality Tested
						</div>
						<div className="feature-card">🌐 Global Delivery</div>
						{/* <div className="feature-card">📞 24/7 Support</div> */}
					</div>

					{/* Trust Info */}
					<div className="product-trust">
						✔ Premium Quality &nbsp; | &nbsp; ✔ Industry Standard
						&nbsp; | &nbsp; ✔ Reliable Support
					</div>

					{/* Why Choose */}
					<div className="product-extra-section">
						<h4>Why Choose This Product?</h4>
						<p>
							Our products are carefully designed and manufactured
							to deliver consistent performance, long service
							life, and excellent value. We focus on quality
							control, modern design, and customer satisfaction at
							every stage.
						</p>
					</div>

					{/* CTA info */}
					<div className="product-cta-text">
						Need more information, pricing details, or customization
						options? Our team is ready to assist you.
					</div>

					{/* Existing Contact Button */}
					<div
						onClick={() => {
							setShowContactModal(true);
						}}
						className="product-detail-ctn-btn"
					>
						<button>Contact Us</button>
					</div>
				</div>
			</div>

			{/* MODAL */}

			<ContactUsModalView
				isOpen={showContactModal}
				onClose={() => setShowContactModal(false)}
			>
				<ContactUsFormComp
					productId={productId}
					productTitle={productTitle}
					setMessageSendFlag={setMessageSendFlag}
				/>
			</ContactUsModalView>
		</div>
	);
};

export default ProductDetails;
